
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/qq",
      function () {
        return require("private-next-pages/android/local/qq/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/local/qq"])
      });
    }
  